import { baseUrl } from 'src/app/global-variables';
import {
  DietsListResponse,
  packageSuggester,
} from './../../../core/model/api-response/plans-response-model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { UserDataService } from '../user-repository/user-data.service';
import { UserRefreshTokenService } from '../user-repository/user-refresh-token.service';

@Injectable({
  providedIn: 'root',
})
export class PlansApiService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService,
    private userRefreshTokenService: UserRefreshTokenService
  ) {}

  getPackageSuggester(
    id: string,
    meal: string,
    page: number,
    day: string
  ): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<packageSuggester>(
        baseUrl +
          'api/v2/diet/' +
          id +
          '/packageSuggester?meal=' +
          meal +
          '&page=' +
          page +
          '&day=' +
          day,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        if (res.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({ packageSuggest: res })
          );
        } else {
          return new GenericResponse(false);
        }
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getPackageSuggester(id, meal, page, day);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  searchPackage(
    id: string,
    meal: string,
    foodName: string,
    day: string
  ): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<packageSuggester>(
        baseUrl +
          'api/v2/diet/' +
          id +
          '/packages?meal=' +
          meal +
          '&foodName=' +
          foodName +
          '&day=' +
          day,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        if (res.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({ packageSuggest: res })
          );
        } else {
          return new GenericResponse(false);
        }
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.searchPackage(id, meal, foodName, day);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  getDietsList(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<DietsListResponse>(baseUrl + 'api/v2/dietType/list', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        // console.log(result);
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({ dietsListCategories: result.categories })
          );
        } else {
          return new GenericResponse(false);
        }
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getDietsList();
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
}
